import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ClientUserGroupMember } from "../../../../api/types/userManagementTypes";
import type { UserGroupDetailsState } from "./userGroupDetailsState";

export interface Props {
  state: UserGroupDetailsState;
  setState: React.Dispatch<React.SetStateAction<UserGroupDetailsState>>;
  hasPermissionToManage: boolean;
  availableMembers: ClientUserGroupMember[];
}

const UserGroupDetailsContext = createContext<Props | undefined>(undefined);

export const UserGroupDetailsContextProvider = ({ children, ...value }: PropsWithChildren<Props>) => (
  <UserGroupDetailsContext value={value}>{children}</UserGroupDetailsContext>
);

export default UserGroupDetailsContext;
